import { render, staticRenderFns } from "./Adquirentes.vue?vue&type=template&id=19ca28b8"
import script from "./Adquirentes.vue?vue&type=script&lang=js"
export * from "./Adquirentes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports